class BundleComponent extends HTMLElement {
    constructor() {
        super();

        this.targetForm = this.dataset.targetForm;
    }

    connectedCallback() {
        if (!this.targetForm) return;

        this.querySelectorAll('input[type="radio"]').forEach(radio => {
            radio.addEventListener('change', (event) => {
                const form = document.querySelector(this.targetForm);

                form.querySelector('input.product-variant-id').value = event.target.value;
                form.querySelector('input[name="product-id"]').value = event.target.value;
            });
        });
    }
}

if (!customElements.get('bundle-component')) {
    customElements.define('bundle-component', BundleComponent);
};